import { httpService } from '../providers/http-service'
import { errorMessage } from '../mixins/error-message'
import { permissions } from '../mixins/permissions'

export const permissionManager = {
  mixins: [ errorMessage, permissions ],
  data () {
    return {
      selectedProduct: null,
      permissions: []
    }
  },
  methods: {
    getProductPermissions (product) {
      this.showSpinner = true
      this.children = {}
      return httpService.getProductPermissions(product.product_public_key).then((res) => {
        this.permissions = res.data.map((perm) => {
          perm.level = this.getLevel(perm)
          return perm
        })
        this.orderPermissions()
        this.showSpinner = false
      }).catch(err => this.showErrorMessage({ err: err }))
    },

    getUserPermissions (product) {
      this.showSpinner = true
      this.children = {}
      return httpService.getUserPermissions(this.company.public_key, product.product_public_key, this.user.public_key).then((res) => {
        this.permissions = res.data.map((perm) => {
          perm.level = this.getLevel(perm)
          return perm
        })
        this.orderPermissions()
        this.showSpinner = false
      }).catch(err => this.showErrorMessage({ err: err }))
    },

    orderPermissions () {
      this.permissions = this.permissions.sort((a, b) => {
        return parseInt(a.hierarchy.replace(/\./g, '')) - parseInt(b.hierarchy.replace(/\./g, ''))
      })
    },

    getChildren (permission) {
      if (!this.children[permission.hierarchy]) {
        const levelNumber = permission.hierarchy.substring(permission.hierarchy.indexOf('0'), -1)
        this.children[permission.hierarchy] = this.permissions.filter((perm) => {
          return perm.hierarchy.startsWith(levelNumber)
        })
      }
      return this.children[permission.hierarchy]
    },

    getLevel (permission) {
      const arr = permission.hierarchy.split('.')
      let level
      for (level = 1; level < arr.length; level++) {
        if (arr[level] === '0') break
      }
      return level
    },

    modifyChildren (permission) {
      const checked = permission.allow_access
      this.getChildren(permission).forEach((perm) => {
        perm.allow_access = checked
      })
      this.$forceUpdate()
    },

    checkAll () {
      this.permissions.forEach((perm) => {
        perm.allow_access = true
      })
      this.$forceUpdate()
    },

    removeUserAccess(user) {
      this.showSpinner = true;
      return httpService.removeUserAccess(this.company.public_key, this.selectedProduct.product_public_key, user.public_key)
      .then(() => {
        this.showSpinner = false
        this.show_toast('success', '', 'Permissões removidas com sucesso!')
      })
      .catch(err => this.showErrorMessage({ err: err }))
    }
  },

  computed: {
    noPermissionSelected() {
      return this.permissions && this.permissions.length > 0 && (this.permissions.filter(perm => perm.allow_access)).length === 0
    },

    removeAccess() {
      return this.modalMode === 'edit' && this.noPermissionSelected
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/permission-manager.js